/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-users" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-users" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-users" */ `./edit.vue` );

const Login = () => import( /* webpackChunkName: "group-users-logged-out" */ `./login.vue` );
const OTP = () => import( /* webpackChunkName: "group-users-logged-out" */ `./otp.vue` );
const Forgot = () => import( /* webpackChunkName: "group-users-logged-out" */ `./forgot.vue` );
const Reset = () => import( /* webpackChunkName: "group-users-logged-out" */ `./reset.vue` );

const Dashboard = () => import( /* webpackChunkName: "group-users-logged-in" */ `../dashboard.vue` );
const Profile = () => import( /* webpackChunkName: "group-users-logged-in" */ `./profile.vue` );
const Security = () => import( /* webpackChunkName: "group-users-logged-in" */ `./security.vue` );

export const users_routes = {
	path: `users`,
	children: [
		{
			path: ``,
			name: `list-users`,
			component: List,
			meta: {
				title: `Users`
			}
		},
		{
			path: `new`,
			name: `add-user`,
			component: Add,
			meta: {
				title: `Add User`
			}
		},
		{
			path: `:uuid`,
			name: `edit-user`,
			component: Edit,
			meta: {
				title: `Edit User`
			}
		}
	]
};

export const users_logged_out_routes = [
	{
		path: ``,
		children: [
			{
				path: ``,
				name: `dashboard`,
				component: Login,
				meta: {
					title: `Log In`
				}
			},
			{
				path: `otp`,
				name: `otp`,
				component: OTP,
				meta: {
					title: `Two-Factor Authentication`
				}
			},
			{
				path: `forgot`,
				name: `forgot`,
				component: Forgot,
				meta: {
					title: `Forgot Password`
				}
			},
			{
				path: `reset`,
				name: `reset`,
				component: Reset,
				meta: {
					title: `Reset Password`
				}
			}
		]
	}
];

export const users_logged_in_routes = [
	{
		path: ``,
		children: [
			{
				path: ``,
				name: `dashboard`,
				component: Dashboard
			},
			{
				path: `otp`,
				redirect: {
					name: `dashboard`
				}
			},
			{
				path: `profile`,
				name: `profile`,
				component: Profile,
				meta: {
					title: `Profile`
				}
			},
			{
				path: `security`,
				name: `security`,
				component: Security,
				meta: {
					title: `Security`
				}
			}
		]
	}
];
